import {
  Component,
  OnInit,
  ViewChild,
  ElementRef,
  AfterViewInit, ChangeDetectorRef,
} from '@angular/core';
import {LayoutService} from './core/layout.service';
import {LayoutInitService} from './core/layout-init.service';
import {SessionHTTPService} from "../../shared/services/session/session-http.service";
import {SessionStore} from "../../shared/services/session/session.store";

@Component({
  selector: 'app-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.scss'],
})
export class LayoutComponent implements OnInit, AfterViewInit {
  // Public variables
  selfLayout = 'default';
  asideSelfDisplay: true;
  asideMenuStatic: true;
  contentClasses = '';
  contentContainerClasses = '';
  toolbarDisplay = true;
  contentExtended: false;
  asideCSSClasses: string;
  asideHTMLAttributes: any = {};
  headerMobileClasses = '';
  headerMobileAttributes = {};
  footerDisplay: boolean;
  footerCSSClasses: string;
  headerCSSClasses: string;
  headerHTMLAttributes: any = {};
  // offcanvases
  extrasSearchOffcanvasDisplay = false;
  extrasNotificationsOffcanvasDisplay = false;
  extrasQuickActionsOffcanvasDisplay = false;
  extrasCartOffcanvasDisplay = false;
  extrasUserOffcanvasDisplay = false;
  extrasQuickPanelDisplay = false;
  extrasScrollTopDisplay = false;
  asideDisplay: boolean;
  @ViewChild('ktAside', {static: true}) ktAside: ElementRef;
  @ViewChild('ktHeaderMobile', {static: true}) ktHeaderMobile: ElementRef;
  @ViewChild('ktHeader', {static: true}) ktHeader: ElementRef;

  constructor(
    private initService: LayoutInitService,
    private layout: LayoutService,
    private sessionHTTPService: SessionHTTPService,
    private sessionStore: SessionStore,
    private cdRef: ChangeDetectorRef,
  ) {
    this.initService.init();
  }

  ngOnInit(): void {
    // build view by layout config settings
    this.asideDisplay = this.layout.getProp('aside.display') as boolean;
    this.toolbarDisplay = this.layout.getProp('toolbar.display') as boolean;
    this.contentContainerClasses = this.layout.getStringCSSClasses('contentContainer');
    this.asideCSSClasses = this.layout.getStringCSSClasses('aside');
    this.headerCSSClasses = this.layout.getStringCSSClasses('header');
    this.headerHTMLAttributes = this.layout.getHTMLAttributes('headerMenu');
    setTimeout(() => {
      this.sessionHTTPService.profileImage().subscribe({
        next: (base64) => {
          base64.then((base64: string) => {
            this.sessionStore.setProfileImage(base64);
            this.sessionStore.currentProfileImage.next(base64);
            this.cdRef.markForCheck();
          })
        }, error: () => {
          this.sessionStore.setProfileImage('/assets/media/svg/avatars/blank.svg');
          this.cdRef.markForCheck();
        }
      })
    }, );
    // console.log(this.sessionService.currentUserValue)
    // if (!this.sessionService.currentUserValue) {
    //   this.sessionHTTPService.whoAmI().subscribe({
    //     next: (me: AuthSuccess['me']) => {
    //       this.sessionService.setCurrentUserValue(me.user);
    //       this.sessionService.setCurrentUserPermissions(me.permissions);
    //     }
    //   })
    // }
  }

  ngAfterViewInit(): void {
    if (this.ktHeader) {
      for (const key in this.headerHTMLAttributes) {
        if (this.headerHTMLAttributes.hasOwnProperty(key)) {
          this.ktHeader.nativeElement.attributes[key] =
            this.headerHTMLAttributes[key];
        }
      }
    }
  }
}
